export default __webpack_public_path__ + "static/media/passed.502e836b.svg";